module.exports = __webpack_public_path__ + "img/pay.2f2c5f9b.svg";